<template>
  <div>
    <WidgetHeroBanner image="membership-banner.jpg" overlayClass="bg-black opacity-50" forceNarrowHeight>
      <template #body>
        <h1 class="text-5xl font-semibold leading-tight md:text-6xl lg:text-7xl">
          Amplify your trading with a membership plan
        </h1>

        <p class="w-full mt-4 leading-relaxed lg:pr-48">
          Get all the support you need to buy and sell more efficiently than ever before with our Silver and Gold
          plans.
        </p>
      </template>
    </WidgetHeroBanner>

    <div ref="membership-plans" class="pb-12 mx-auto memberships max-w-7xl md:pb-24 container-padding-x">
      <WidgetPremiumExpireBanner
        v-if="appIs.isLegacyPremiumSubscriber"
        class="mx-auto mt-6 plan-banner md-12 md:mb-24"
      />

      <WidgetPlatinumPlanBanner v-if="appIs.platinum" class="mx-auto mt-6 plan-banner md-12 md:mb-24" />

      <WidgetMembershipPlans origin="membership plans page" showPlatinum class="md:-mt-16" />
    </div>

    <WidgetTestimonials
      :isDynamic="false"
      heading="Testimonials"
      subHeading="Don’t take our word for it, see what our premium members say..."
    >
      <template #testimonialOne>
        <p class="block mb-2 leading-relaxed">
          Was looking for some sheep on the site, saw some come up close by so signed up to be a member to be able
          to contact immediately. The sheep arrived on farm yesterday! Also saw a ram advertised by someone I know,
          and bought that as well. Really happy with the site and membership was worth it!
        </p>

        <p class="block text-sm font-semibold">G Hiscock - Dorset</p>
      </template>

      <template #testimonialTwo>
        <p class="block mb-2 leading-relaxed">
          I have found SellMyLivestock a very easy way to buy livestock and have now bought a group of suckler cows
          and two groups of shearling ewes from the site. All the transactions have been easy and straight forward
          and I like the ease of having access to animals for sale across the whole country. I will be using the
          site again and intend to sell some stores and breeding heifers through the site.
        </p>

        <p class="block text-sm font-semibold">A Thomas - Wales</p>
      </template>
    </WidgetTestimonials>

    <WidgetPromoBanner class="bg-brand-darker">
      <template #body>
        <h3 class="text-lg font-semibold text-center text-white md:text-xl lg:text-3xl">
          Join over {{ userTotal }} forward thinking farmers and take advantage of a membership plan to amplify
          your trading, starting from just £69 per year
          <span class="text-sm md:text-lg">+ VAT</span>
        </h3>

        <UtilButton @click="goToPlans" :block="$breakpoint.xs" color="primary" class="mx-auto mt-6 font-medium">
          Become a member
        </UtilButton>
      </template>
    </WidgetPromoBanner>

    <WidgetFaqPremiumMembership id="membership_faqs" @choose-plan="goToPlans" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import UtilButton from '@/components/utils/UtilButton'
import WidgetHeroBanner from '@/components/widgets/WidgetHeroBanner'
import WidgetPromoBanner from '@/components/widgets/WidgetPromoBanner'
import WidgetFaqPremiumMembership from '@/components/widgets/WidgetFaqPremiumMembership'
import WidgetTestimonials from '@/components/widgets/WidgetTestimonials'
import WidgetMembershipPlans from '@/components/widgets/WidgetMembershipPlans'
import WidgetPremiumExpireBanner from '@/components/widgets/WidgetPremiumExpireBanner'
import WidgetPlatinumPlanBanner from '@/components/widgets/WidgetPlatinumPlanBanner'

export default {
  name: 'PremiumMembership',

  components: {
    UtilButton,
    WidgetHeroBanner,
    WidgetPromoBanner,
    WidgetFaqPremiumMembership,
    WidgetTestimonials,
    WidgetMembershipPlans,
    WidgetPremiumExpireBanner,
    WidgetPlatinumPlanBanner
  },

  computed: {
    ...mapGetters({
      userTotal: 'stats/getUserTotal'
    })
  },

  created() {
    this.$store.dispatch('stats/getStats')
  },

  methods: {
    goToPlans() {
      this.$nextTick(() => {
        this.$scroll.intoViewIfNeeded(this.$refs['membership-plans'])
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.memberships {
  position: relative;
  z-index: 2;
}

@media (min-width: 1111px) {
  .plan-banner {
    position: relative;
    right: -70px;
  }
}
</style>
